import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

// Lazy: the page uses Ant Design, which stays out of the main dashboard bundle.
const Track123 = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/track123'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'track123_settings_index',
          component: Track123,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
